/**
 * 基金js
 */

import gotowap from "../src/modules/gotowap";
import gonggao from "../src/modules/gonggao";
declare var stockEnity:any
gotowap(stockEnity.stockCode, stockEnity.MktNum);

//公告
var gg = new gonggao({
    boxid: "#stock-gonggao-wap",
    size: 5,
    market: stockEnity.MktNum,
    stockcode: stockEnity.stockCode
});


/**
 * 自选股相关功能
 */
import quote_zxg from "../src/modules/newzxg/quote_zxg_b";
quote_zxg(stockEnity.fullcode,{
    leftcount: 5,
    ignore_btn:true
})


require('../src/modules/old_fund/fundstock')